import { Pipe, PipeTransform } from '@angular/core';
import { InstallationReceivedPluginService } from './received.service';

@Pipe({
    name: 'receivedstatus',
    standalone: false
})
export class ReceivedStatusPipe implements PipeTransform {
  public statuses: any[];

  constructor(private service: InstallationReceivedPluginService) {
    this.statuses = this.service.getStatuses();
  }

  transform(id: string): any {
    return this.service.getValue(parseInt(id), this.statuses);
  }
}
